<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <argon-button :to="{ name: 'Unit Kerja' }" isRouteLink outline><font-awesome-icon
                  icon="fa-solid fa-chevron-left" /> Kembali</argon-button>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <argon-button>Simpan</argon-button>
                    <argon-button :to="{ name: 'Unit Kerja' }" isRouteLink outline>Batalkan</argon-button>
                  </div>
                </div>
              </template>
              <FieldsetComponent title="Unit Kerja"
                description="Silakan isi informasi Unit Kerja sesuai dengan yang ada di dalam organisasi.">
                <div class="flex flex-col gap-5">
                  <form-group label="Nama Unit Kerja" idinput="name">
                    <input-form type="text" name="name" v-model="data.name" idinput="name"
                      placeholder="Silakan tulis unit nama kerja disini..." />
                  </form-group>

                  <form-group label="Kode Unit Kerja" idinput="code">
                    <input-form type="text" name="code" v-model="data.code" idinput="code"
                      placeholder="Silakan tulis kode unit kerja disini..." :disabled="data?.code != null && data?.code != '' && currentCode != ''" />
                  </form-group>

                  <form-group label="Pemimpin Unit Kerja" idinput="leader_id">
                    <select-form name="leader_id" idinput="leader_id" v-model="data.leader_id" placeholder="Pilih pemimpin unit kerja" :options="employee.map((item) => {
                      return {
                        value: item.id,
                        text: item.name,
                      };
                    })" />
                  </form-group>

                  <form-group label="Keterangan Unit Kerja" idinput="description">
                    <input-form type="text" name="description" v-model="data.description" idinput="description"
                      placeholder="Silakan tulis keterangan unit kerja disini..." />
                  </form-group>

                  <!-- <form-group v-if="this.$route.params.id" label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <argon-radio id="status_0" name="status" text="Aktif" v-model="data.status" value="active" />
                      <argon-radio id="status_1" name="status" text="Non Aktif" v-model="data.status" value="inactive" />
                    </div>
                  </form-group> -->

                  <!-- <form-group v-if="this.$route.params.id" label="Level Unit"> -->
                  <form-group label="Level Unit">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <argon-radio id="cabin" name="unit" text="Cabang Induk" v-model="data.level" value="1" />
                      <argon-radio id="capem" name="unit" text="Cabang Pembantu" v-model="data.level" value="2" />
                      <argon-radio id="kas" name="unit" text="Kantor Kas" v-model="data.level" value="3" />
                    </div>
                  </form-group>
                  <!-- CABANG PEMBANTU -->
                  <!-- apabila cabang pembantu dipilih, muncul field untuk pilih cabang induk -->
                  <template v-if="Number.parseInt(data.level) === 2">
                    <form-group v-if="list_cabang.length > 0" label="Silakan Pilih Cabang Induk">
                      <select
                        v-model="data.parent_cabang"
                        class="form-select"
                      >
                        <option value="">Pilih Cabang</option>
                        <option v-for="item in list_cabang" :key="item" :value="item.id">{{ item.name }}</option>
                      </select>
                    </form-group>
                    <!-- apabila cabang induk belum ada maka ada informasi berikut  -->
                    <p v-else class="py-3 px-10 text-center border">Cabang induk belum tersedia, silakan tentukan cabang induk terlebih dahulu agar bisa membuat cabang pembantu.</p>
                  </template>

                  <!-- KANTOR KAS -->
                  <!-- apabila Kantor kas terpilih, muncul field untuk pilih cabang pembantu
                       cabang pembantu sudah merepresentasikan cabang induk, jadi tidak perlu dipilih kembali.
                       apabila secara integrasi takes time untuk dilakukan, maka bisa dibuat 2 hirarki select.
                  -->

                  <!-- Special Case
                        Kantor kas (level 3) bisa direct langsung ke cabang induk (level 1)
                        tanpa harus memilih cabang pembantu (level 2)
                  -->

                  <template v-if="Number.parseInt(data.level) === 3">
                    <div class="form-check py-2">
                      <input class="form-check-input" type="checkbox" id="level" v-model="data.level2_null">
                      <label class="form-check-label" for="level">
                        Unit kerja <strong>{{ data?.name }}</strong> ditempatkan di Cabang Induk (tidak di cabang pembantu)
                      </label>
                    </div>
                    <!-- <form-group v-if="list_cabang.length > 0 && data.level2_null === 1" label="Silakan Pilih Cabang Induk">
                      <select
                        v-model="data.parent_cabang"
                        class="form-select"
                      >
                        <option value="">Pilih Cabang</option>
                        <option value="">IT Department</option>
                        <option value="">Cabang Induk 2</option>
                        <option value="">Cabang Induk 3</option>
                        <option value="">Cabang Induk 4</option>
                        <option value="">Cabang Induk 5</option>
                      </select>
                    </form-group> -->

                    <form-group v-if="list_cabang.length > 0" :label="data.level2_null ? 'Silakan Pilih Cabang Induk' : 'Silakan Pilih Cabang Pembantu'">
                        <!-- v-model="data.parent_cabang" -->
                      <select
                        v-model="data[data.level2_null ? 'parent_cabang' : 'parent_capem']"
                        class="form-select"
                      >
                        <option value="">Pilih Cabang</option>
                        <option v-for="item in list_cabang" :key="item" :value="item.id">{{ item.name }}</option>
                      </select>
                    </form-group>

                    <!-- end special case -->

                    <!-- <form-group v-else-if="list_cabang.length > 0 && data.level2_null === 0" label="Silakan Pilih Cabang Pembantu">
                      <select
                        v-model="data.parent_capem"
                        class="form-select"
                      >
                        <option value="">Pilih Cabang</option>
                        <option value="">Design</option>
                        <option value="">Cabang Pembantu 2</option>
                        <option value="">Cabang Pembantu 3</option>
                        <option value="">Cabang Pembantu 4</option>
                        <option value="">Cabang Pembantu 5</option>
                      </select>
                    </form-group> -->

                    <!-- apabila cabang pembantu belum ada maka ada informasi berikut  -->
                    <p v-else class="py-3 px-10 text-center border">Cabang pembantu belum tersedia, silakan tentukan cabang pembantu terlebih dahulu agar bisa membuat kantor kas.</p>
                  </template>
                  
                </div>
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import InputForm from "@/components/InputForm.vue";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue"
import MetaSection from "@/components/MetaSection.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";
import SelectForm from '@/components/SelectForm.vue';

import EmployeeApi from "@/repository/api/EmployeeApi";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";

export default {
  name: "profile",
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    InputForm,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    ArgonRadio,
    SelectForm,
  },
  data() {
    return {
      showMenu: false,
      jabatan: {},
      data: {
        // // leader_id: "",
        // level: "",
        // level2_null: false,
        // parent_cabang: '',
        // parent_capem: '',


        level: '',
        // level2_null: false,
        level2_null: true,
        parent_cabang: '',
        parent_capem: '',
        name: '',
        code: '',
        description: '',
        leader_id: '',
      },
      currentCode: "",
      unitKerja: [],
      employee: [],
      selectedEmployeeAdd: "",
      optionEmployee: [
        {
          id: "abc",
          text: "xyz",
        },
      ],
      optionUnitKerja: [],
      optionJabatan: [],
      myValue: '',

      list_cabang: [],

      is_get_data: false,
    };
  },
  watch: {
    'data.level'(newVal) {
        if (Number.parseInt(newVal) === 2 || Number.parseInt(newVal) === 3) {
          if (Number.parseInt(newVal) === 3 && !this.is_get_data) {
            this.data.level2_null = false;
          }
  
          this.getCabang();
        }
  
      if (!this.is_get_data) {
        this.data.parent_cabang = '';
        this.data.parent_capem = '';
      }
    },
    'data.level2_null'(newVal) {
      if (!this.is_get_data) {
        if (newVal) {
          this.data.parent_capem = '';
        } else {
          this.data.parent_cabang = '';
        }
      }
      this.getCabang();
    },
  },
  async mounted() {
    await this.getEmployee();
    if (this.$route.params.id) {
      await this.getData();
      this.currentCode = JSON.parse(JSON.stringify(this.data?.code ?? ""))
    }
  },
  methods: {
    async submit() {
      this.$store.state.loading = true;
      // console.log(this.data)
      // let data = JSON.parse(JSON.stringify(this.data));
      let data = {
        level: this.data?.level,
        level2_null: this.data?.level2_null ? 1 : 0,
        parent_cabang: this.data?.parent_cabang,
        parent_capem: this.data?.parent_capem,
        name: this.data?.name,
        code: this.data?.code,
        description: this.data?.description,
        leader_id: this.data?.leader_id,
      };

      if (this.$route.params.id) {

        await UnitKerjaApi.update(this.$route.params.id, data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Unit Kerja" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message ?? "",
          });
        });
      }
      else {
        await UnitKerjaApi.post(data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Unit Kerja" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message ?? "",
          });
        });
      }
      this.$store.state.loading = false;
    },
    async getEmployee() {
      this.$store.state.loading = true;
      await EmployeeApi.getbyparam({page: "all", status: "active", view_option:"1"})
        .then((response) => {
          this.employee = response.data;
          this.optionEmployee = this.employee.map((item) => {
            return {
              id: item.id,
              text: item.name,
            };
          });
        })
        .catch(() => {
          this.employee = [];
        });
      this.$store.state.loading = false;
    },

    async getCabang() {
      this.$store.state.loading = true;
      
      let level = this.data.level - 1;
      if (Number.parseInt(this.data.level) === 3 && this.data.level2_null) {
        level = 1;
      }

      await UnitKerjaApi.getbyparam({
        page: 'all',
        level,
      })
      .then((response) => {
        // console.log(response)
        this.list_cabang = response?.data;

      }).catch((error) => {
        console.log(error)
      });
      this.$store.state.loading = false;
    },

    async getData() {
      this.$store.state.loading = true;
      await UnitKerjaApi.get(this.$route.params.id).then((response) => {
        this.is_get_data = true;
        const data = response.data;

        this.data.level = data?.level;
        this.data.level2_null = data?.level2_null === 1 ? true : false;
        this.data.parent_cabang = data?.parent_cabang;
        this.data.parent_capem = data?.parent_capem;
        this.data.name = data?.name;
        this.data.code = data?.code;
        this.data.description = data?.description;
        this.data.leader_id = data?.leader_id;

        // this.is_get_data = false;
        setTimeout(() => {
          this.is_get_data = false;
        }, 500);

      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error?.response?.data?.message,
        }).then(() => {
          this.$router.push({ name: "Unit Kerja" });
        });
      })
      this.$store.state.loading = false;
    }
  },
};
</script>
